import React, { useEffect, useState } from 'react';
import styles from './RangeAnalysisTab_ace.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useRangeAnalysisVehicleData } from './Context';
import moment from 'moment';
import NoDataFound from '../../../Shared/NoDataFound';
import ChartLoader from '../../../Shared/Loader';

const FleetVehiclePerformance = () => {
  const [sortOrder, setSortOrder] = useState("top");
  const [expandedRows, setExpandedRows] = useState({});
  const [vehicleData, setVehicleData] = useState([])
  const { GlobalData, setGlobalData } = useRangeAnalysisVehicleData()

  const { isLoading, error, sendReq: fetchData } = useHttp();

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + `ace_range_analysis/fleet_vehicle_performance_${sortOrder}`, body: { filterdata: GlobalData } },
      (data) => {
        setVehicleData(data)
      }
    )
  }, [GlobalData, sortOrder])


  const toggleDropdown = (rowIndex) => {
    setExpandedRows(prev => ({
      // ...prev,
      [rowIndex]: !prev[rowIndex]
    }));
  };

  const renderMetricsRow = (row) => (
    <tr style={{ backgroundColor: '#f8fafc' }}>
      <td colSpan="5" style={{ padding: '16px 20px', borderTop: '1px solid #e2e8f0' }}>
        <div
          className={`row g-3 ${styles.metricsRow}`}
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            padding: '16px',
            margin: '0',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e2e8f0'
          }}
        >
          <div className="col-2">
            <div className={`${styles.metricItem} ${styles.tableCardBorder} d-flex flex-column justify-content-between`}>
              <div className={`${styles.metricLabel} ${styles.tableCards}`}>Speed</div>
              <div className={styles.metricValueSmall} >{row?.percentageTimeSpentInSpeed_20_40 !== null ? row?.percentageTimeSpentInSpeed_20_40?.toFixed(2) + " km/hr" : "--"} </div>
            </div>
          </div>
          <div className="col-2">
            <div className={`${styles.metricItem} ${styles.tableCardBorder} d-flex flex-column justify-content-between`}>
              <div className={`${styles.metricLabel} ${styles.tableCards}`}>Acc. Pedal Position</div>
              <div className={styles.metricValueSmall} >{row?.percentageTimeSpentInMcu_throttle_position_10_30 !== null ? row?.percentageTimeSpentInMcu_throttle_position_10_30?.toFixed(2) + " %" : "--"}</div>
            </div>
          </div>
          <div className="col-2">
            <div className={`${styles.metricItem} ${styles.tableCardBorder} d-flex flex-column justify-content-between`}>
              <div className={`${styles.metricLabel} ${styles.tableCards}`}>RPM Band</div>
              <div className={styles.metricValueSmall} >{row?.percentageTimeSpentInMotorspeed_3000_5000 !== null ? row?.percentageTimeSpentInMotorspeed_3000_5000?.toFixed(2) + " RPM" : "--"}</div>
            </div>
          </div>
          <div className="col-2">
            <div className={`${styles.metricItem} ${styles.tableCardBorder} d-flex flex-column justify-content-between`}>
              <div className={`${styles.metricLabel} ${styles.tableCards}`}>Regeneration</div>
              <div className={styles.metricValueSmall} >{row?.percentageRegen !== null ? row?.percentageRegen?.toFixed(2) + " %" : "--"}</div>
            </div>
          </div>
          <div className="col-2">
            <div className={`${styles.metricItem} ${styles.tableCardBorder} d-flex flex-column justify-content-between`} >
              <div className={`${styles.metricLabel} ${styles.tableCards}`}>Idling</div>
              <div className={styles.metricValueSmall} >{row?.percentageTimeSpentInSpeed_0 !== null ? row?.percentageTimeSpentInSpeed_0?.toFixed(2) + " %" : "--"}</div>
            </div>
          </div>
          <div className="col-2">
            <div className={`${styles.metricItem} ${styles.tableCardBorder} d-flex flex-column justify-content-between`}>
              <div className={`${styles.metricLabel} ${styles.tableCards}`}>Coasting</div>
              <div className={styles.metricValueSmall}>{row?.percentageTimeSpentInCoasting_1 !== null ? row?.percentageTimeSpentInCoasting_1?.toFixed(2) + " %" : "--"}</div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );

  function formatDateTimeAmPm(timeStr) {
    return moment(timeStr, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY hh:mm A");
  }


  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center gap-3">
            <h5 className={`card-title ${styles.cardTitle}`}>Fleet Vehicle Performance (On a Single Charge)</h5>
          </div>
          <div className="btn-group" role="group">
            <button
              type="button"
              className={`btn btn-sm ${styles.tableToggleBtn}`}
              style={{
                border: '1px solid #358696',
                backgroundColor: sortOrder === 'top' ? '#358696' : '#fff',
                color: sortOrder === 'top' ? '#fff' : '#358696',
                fontWeight: 500,
                borderTopLeftRadius: '6px',
                borderBottomLeftRadius: '6px',
                transition: 'all 0.2s ease',
              }}
              onClick={() => setSortOrder('top')}
            >
              Top
            </button>

            <button
              type="button"
              className={`btn btn-sm ${styles.tableToggleBtn}`}
              style={{
                border: '1px solid #358696',
                backgroundColor: sortOrder === 'bottom' ? '#358696' : '#fff',
                color: sortOrder === 'bottom' ? '#fff' : '#358696',
                fontWeight: 500,
                borderTopRightRadius: '6px',
                borderBottomRightRadius: '6px',
                transition: 'all 0.2s ease',
              }}
              onClick={() => setSortOrder('bottom')}
            >
              Bottom
            </button>
          </div>
        </div>
        {/* Table */}
        <div className="table-responsive" style={{ height: "400px", overflowY: "auto", overflowX: "auto" }}>
          <table className="table table-hover align-middle" >
            <thead className={styles.tableHeader}
              style={{ position: "sticky", top: 0, zIndex: 1 }}>
              <tr>
                <th scope="col" className={`fw-semibold ${styles.tableHeaderText}`}>Vehicle Details</th>
                <th scope="col" className={`fw-semibold ${styles.tableHeaderText}`}>Duration</th>
                <th scope="col" className={`fw-semibold ${styles.tableHeaderText}`}>Distance</th>
                <th scope="col" className={`fw-semibold ${styles.tableHeaderText}`}>Energy Consumption</th>
                <th scope="col" className={`fw-semibold ${styles.tableHeaderText}`}>Energy Efficiency</th>
              </tr>
            </thead>
            <tbody >
              {
                isLoading ? <ChartLoader />
                  : vehicleData?.length ? vehicleData?.map((row, index) => (
                    <React.Fragment key={index}>
                      <tr className={styles.tableRowWithDropdown}>
                        <td>
                          <div className={styles.vehicleDetailsText}>{row?.vehicleId !== null ? row?.vehicleId : " "}{" "}{row?.vehicle_registration_number !== null ? row?.vehicle_registration_number : " "}</div>
                        </td>
                        <td className="text-muted small">{formatDateTimeAmPm(row?.dischargeStartEventDateTime)} - {formatDateTimeAmPm(row?.dischargeEndEventDateTime)}</td>
                        <td className="text-muted">{row?.dischargeDistanceKm !== null ? parseFloat(row?.dischargeDistanceKm?.toFixed(2)) + " km" : "--"}</td>
                        <td>
                          <div className="text-muted my-2">{row?.dischargeTotalWhConsumed !== null ? parseFloat(row?.dischargeTotalWhConsumed?.toFixed(2)) + " kWh" : "--"} </div>
                        </td>
                        <td className="position-relative">
                          <div className="text-muted">{row?.Energy_Efficiency !== null ? row?.Energy_Efficiency?.toFixed(2) + " kWh/km" : "--"} </div>
                          <div
                            className={`${styles.dropdownArrow}  mb-3`}
                            onClick={() => toggleDropdown(index)}
                            style={{ cursor: 'pointer', transform: expandedRows[index] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M4 6L8 10L12 6" stroke="#8cacd4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                        </td>
                      </tr>
                      {expandedRows[index] && renderMetricsRow(row)}
                    </React.Fragment>
                  )) :
                    <NoDataFound />
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FleetVehiclePerformance;